import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useDraftOrder = (order, enabled) => {
  return useQuery({
    queryKey: ["draftOrder", order],
    enabled: enabled,
    queryFn: async () =>
      callApi({
        path: "draftordercard",
        command: "get",
        data: JSON.stringify({ data: { filter: { noFilter: order } } }),
      }),
  });
};
